import { FunctionComponent, ReactElement, useContext, useRef } from 'react';
import styled from 'styled-components';
import { GenderInput, GenderInputDS, SelectedButton } from '../../components/DesignSystem';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { ValidityHtmlElement } from '../../utils/DsType';

const CreditsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  width: 100%;
  // @media (min-width: 1024px) {
  //   height: 150px;
  // }
`;

const Subtitle = styled.div`
  font-size: var(--typo-title2-font-size);
  line-height: var(--typo-title2-line-height);
  color: var(--colors-on-background);
  font-family: var(--typo-title1-font-family);
  letter-spacing: var(--typo-title1-letter-spacing);
  font-weight: var(--typo-title1-font-weight);
  @media (min-width: 1024px) {
    font-size: var(--typo-title1-font-size);
    line-height: var(--typo-title1-line-height);
  }
`;
const ProjectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  .btn {
    max-width: 40px;
    left: 60%;
    position: relative;
    padding: 0;
  }
  .to-validate {
    :host(buttonContainer) {
      margin-right: 0;
      margin-left: auto;
      background: green;
    }
    div {
      margin-right: 0;
      margin-left: auto;
    }
  }
`;
const Recapitulatif: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const projectRef = useRef<GenderInputDS>(null);
  const projectRef2 = useRef<GenderInputDS>(null);
  const {
    state: { consents },
    geoLoc,
    dispatch,
  } = useContext(store);
  const onProjectChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!projectRef && projectRef.current !== null) {
      (projectRef.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(updateStore({ consents: { cetelemProject: e.currentTarget?.value } }));
    }
  };
  const onDossierChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!projectRef2 && projectRef2.current !== null) {
      (projectRef2.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(updateStore({ consents: { dossierBoolean: e.currentTarget?.value } }));
    }
  };
  return (
    <>
      {geoLoc === 'CTLM' && (
        <CreditsContainer>
          <GenderInput
            ref={projectRef}
            class="to-validate trackable-click"
            label="Êtes-vous déjà client Cetelem ?"
            data-id="cetelemProject"
            onSelectedElementChange={onProjectChange}
            value={consents?.cetelemProject}
            error-message="Veuillez choisir Oui ou Non."
          >
            <SelectedButton className="btn" value={true} secondary>
              Oui
            </SelectedButton>
            <SelectedButton className="btn" value={false} secondary>
              Non
            </SelectedButton>
          </GenderInput>
          <ProjectContainer>
            <Subtitle>Boostez la prise en charge de votre dossier</Subtitle>
            <GenderInput
              ref={projectRef2}
              class="to-validate trackable-click"
              label="Dans l'hypothèse où Cetelem* ne pourrait donner une suite favorable à votre projet, acceptez-vous que BNP Paribas Personal Finance transmette vos données d'identification, de contact et celles permettant d'étudier votre solvabilité à l'un de ses partenaires Credit Market** ou Eddy*** ou Meilleur Taux****, aléatoirement sélectionné afin de lui permettre d’étudier votre dossier en vue de la proposition éventuelle d’un regroupement de crédits. Ces informations étant protégées par le secret professionnel, votre consentement vise également expressément la levée du secret bancaire à cette meme fin, à l’égard du partenaire sélectionné. Si vous acceptez, ce partenaire vous contactera par téléphone ou par mail pour vous préciser ses coordonnées, vous proposer éventuellement une offre de regroupement de crédits et vous informer du mode opératoire quant au suivi de votre dossier."
              data-id="cetelemProject"
              onSelectedElementChange={onDossierChange}
              value={consents?.dossierBoolean}
              error-message="Veuillez choisir Oui ou Non."
            >
              <SelectedButton value={true} secondary>
                Oui
              </SelectedButton>
              <SelectedButton value={false} secondary>
                Non
              </SelectedButton>
            </GenderInput>
          </ProjectContainer>
        </CreditsContainer>
      )}
      {geoLoc !== 'CTLM' && (
        <CreditsContainer>
          <GenderInput
            ref={projectRef}
            class="to-validate trackable-click"
            label="Êtes-vous déjà client Crédit Moderne? "
            data-id="cetelemProject"
            onSelectedElementChange={onProjectChange}
            value={consents?.cetelemProject}
            error-message="Veuillez choisir Oui ou Non."
          >
            <SelectedButton className="btn" value={true} secondary>
              Oui
            </SelectedButton>
            <SelectedButton className="btn" value={false} secondary>
              Non
            </SelectedButton>
          </GenderInput>
        </CreditsContainer>
      )}
    </>
  );
};

export default Recapitulatif;
